

































































































































import Vue from 'vue'
import { QcqOperations } from '@/types/enums'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'
import { SimpleWeekTimeModelDialog } from '@/types'

interface ComponentData {
  id: string
  name: string
  MDT_IDENT_NR: string
  MOD_IDENT_NR: string
  ABW: string
  KAL: string
  monday: string
  tuesday: string
  wednesday: string
  thursday: string
  friday: string
  saturday: string
  sunday: string
  formIsValid: boolean
  validationRules: Array<Function>
  remove: number
  typeList: Array<string>
  selectedType: string | undefined
  isCreate: boolean
  mondayFrom: string
  mondayTo: string
  tuesdayFrom: string
  tuesdayTo: string
  wednesdayFrom: string
  wednesdayTo: string
  thursdayFrom: string
  thursdayTo: string
  fridayFrom: string
  fridayTo: string
  saturdayFrom: string
  saturdayTo: string
  sundayFrom: string
  sundayTo: string
}

export default Vue.extend({
  name: 'TimeModelEditorDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    timeModelDialogData: {
      type: Object as () => SimpleWeekTimeModelDialog
    },

    timeModelItem: {
      type: Object as () => SimpleWeekTimeModel
    },

    operation: {
      type: Number
    },

    loading: {
      type: Boolean
    }
  },

  data (): ComponentData {
    return {
      id: '',
      name: '',
      MDT_IDENT_NR: '',
      MOD_IDENT_NR: '',
      ABW: '00:00',
      KAL: '00:00',
      monday: '00:00',
      tuesday: '00:00',
      wednesday: '00:00',
      thursday: '00:00',
      friday: '00:00',
      saturday: '00:00',
      sunday: '00:00',
      formIsValid: false,
      validationRules: [
        (v: string): boolean | string => !!v || this.$t('errors.required').toString()
      ],
      remove: QcqOperations.REMOVE,
      typeList: ["M", "S"],
      selectedType: undefined,
      isCreate: false,
      mondayFrom: '',
      mondayTo: '',
      tuesdayFrom: '',
      tuesdayTo: '',
      wednesdayFrom: '',
      wednesdayTo: '',
      thursdayFrom: '',
      thursdayTo: '',
      fridayFrom: '',
      fridayTo: '',
      saturdayFrom: '',
      saturdayTo: '',
      sundayFrom: '',
      sundayTo: '',
    }
  },

 /* watch: {
    timeModelDialogData (newVal: SimpleWeekTimeModelDialog | undefined): void {
      if (newVal) {
        const form: any = this.$refs['timeForm']
        if(form) {
          form.resetValidation()
        }

        this.isCreate = newVal.operation === QcqOperations.ADD
        const check = newVal.operation === QcqOperations.ADD || newVal.timeModel === undefined
        const empty = '00:00'

        this.id = check ? '' : newVal.timeModel!.id
        this.name = check ? '' : newVal.timeModel!.name
        this.MDT_IDENT_NR = check ? '' : newVal.timeModel!.MDT_IDENT_NR
        this.MOD_IDENT_NR = check ? '' : newVal.timeModel!.MOD_IDENT_NR
        this.ABW = check ? empty : newVal.timeModel!.ABW
        this.KAL = check ? empty : newVal.timeModel!.KAL
        this.monday = check ? empty : newVal.timeModel!.monday
        this.mondayFrom = check ? '' : newVal.timeModel!.mondayFrom ? newVal.timeModel!.mondayFrom : ''
        this.mondayTo = check ? '' : newVal.timeModel!.mondayTo ? newVal.timeModel!.mondayTo : ''
        this.tuesday = check ? empty : newVal.timeModel!.tuesday
        this.tuesdayFrom = check ? '' : newVal.timeModel!.tuesdayFrom ? newVal.timeModel!.tuesdayFrom : ''
        this.tuesdayTo = check ? '' : newVal.timeModel!.tuesdayTo ? newVal.timeModel!.tuesdayTo : ''
        this.wednesday = check ? empty : newVal.timeModel!.wednesday
        this.wednesdayFrom = check ? '' : newVal.timeModel!.wednesdayFrom ? newVal.timeModel!.wednesdayFrom : ''
        this.wednesdayTo = check ? '' : newVal.timeModel!.wednesdayTo ? newVal.timeModel!.wednesdayTo : ''
        this.thursday = check ? empty : newVal.timeModel!.thursday
        this.thursdayFrom = check ? '' : newVal.timeModel!.thursdayFrom ? newVal.timeModel!.thursdayFrom : ''
        this.thursdayTo = check ? '' : newVal.timeModel!.thursdayTo ? newVal.timeModel!.thursdayTo : ''
        this.friday = check ? empty : newVal.timeModel!.friday
        this.fridayFrom = check ? '' : newVal.timeModel!.fridayFrom ? newVal.timeModel!.fridayFrom : ''
        this.fridayTo = check ? '' : newVal.timeModel!.fridayTo ? newVal.timeModel!.fridayTo : ''
        this.saturday = check ? empty : newVal.timeModel!.saturday
        this.saturdayFrom = check ? '' : newVal.timeModel!.saturdayFrom ? newVal.timeModel!.saturdayFrom : ''
        this.saturdayTo = check ? '' : newVal.timeModel!.saturdayTo ? newVal.timeModel!.saturdayTo : ''
        this.sunday = check ? empty : newVal.timeModel!.sunday
        this.sundayFrom = check ? '' : newVal.timeModel!.sundayFrom ? newVal.timeModel!.sundayFrom : ''
        this.sundayTo = check ? '' : newVal.timeModel!.sundayTo ? newVal.timeModel!.sundayTo : ''
        this.selectedType = check ? undefined : newVal.timeModel!.modelType
      }
    }
  },*/

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onFormSubmit (): void {
      const form: any = this.$refs['timeForm']

      const timeModel = new SimpleWeekTimeModel(
        this.id,
        this.name,
        this.createString(this.ABW!),
        this.createString(this.KAL!),
        this.MDT_IDENT_NR,
        this.MOD_IDENT_NR,
        this.createString(this.monday!),
          this.mondayFrom ? this.mondayFrom : this.mondayTo ? '00:00' : null,
          this.mondayTo ? this.mondayTo : this.mondayFrom ? '23:59' : null,
        this.createString(this.tuesday!),
          this.tuesdayFrom ? this.tuesdayFrom : this.tuesdayTo ? '00:00' : null,
          this.tuesdayTo ? this.tuesdayTo : this.tuesdayFrom ? '23:59' : null,
        this.createString(this.wednesday!),
          this.wednesdayFrom ? this.wednesdayFrom : this.wednesdayTo ? '00:00' : null,
          this.wednesdayTo ? this.wednesdayTo : this.wednesdayFrom ? '23:59' : null,
        this.createString(this.thursday!),
          this.thursdayFrom ? this.thursdayFrom : this.thursdayTo ? '00:00' : null,
          this.thursdayTo ? this.thursdayTo : this.thursdayFrom ? '23:59' : null,
        this.createString(this.friday!),
          this.fridayFrom ? this.fridayFrom : this.fridayTo ? '00:00' : null,
          this.fridayTo ? this.fridayTo : this.fridayFrom ? '23:59' : null,
        this.createString(this.saturday!),
          this.saturdayFrom ? this.saturdayFrom : this.saturdayTo ? '00:00' : null,
          this.saturdayTo ? this.saturdayTo : this.saturdayFrom ? '23:59' : null,
        this.createString(this.sunday!),
          this.sundayFrom ? this.sundayFrom : this.sundayTo ? '00:00' : null,
          this.sundayTo ? this.sundayTo : this.sundayFrom ? '23:59' : null,
        this.timeModelItem ? this.timeModelItem.validFrom : '',
        this.selectedType!)

      if (this.operation === QcqOperations.REMOVE) {
        this.$emit('save', timeModel)
        return
      }

      if (form.validate()) {
        this.$emit('save', timeModel)
      }
    },

    createString (time: string): string {
      const h = time.split(':')[0]
      const m = time.split(':')[1]
      const minutes = (Number(h) * 60) + Number(m)
      return minutes.toString()
    }
  },

  mounted () {
    if (this.timeModelDialogData) {
      const form: any = this.$refs['timeForm']
      if(form) {
        form.resetValidation()
      }

      this.isCreate = this.timeModelDialogData.operation === QcqOperations.ADD
      const check = this.timeModelDialogData.operation === QcqOperations.ADD || this.timeModelDialogData.timeModel === undefined
      const empty = '00:00'

      this.id = check ? '' : this.timeModelDialogData.timeModel!.id
      this.name = check ? '' : this.timeModelDialogData.timeModel!.name
      this.MDT_IDENT_NR = check ? '' : this.timeModelDialogData.timeModel!.MDT_IDENT_NR
      this.MOD_IDENT_NR = check ? '' : this.timeModelDialogData.timeModel!.MOD_IDENT_NR
      this.ABW = check ? empty : this.timeModelDialogData.timeModel!.ABW
      this.KAL = check ? empty : this.timeModelDialogData.timeModel!.KAL
      this.monday = check ? empty : this.timeModelDialogData.timeModel!.monday
      this.mondayFrom = check ? '' : this.timeModelDialogData.timeModel!.mondayFrom ? this.timeModelDialogData.timeModel!.mondayFrom : ''
      this.mondayTo = check ? '' : this.timeModelDialogData.timeModel!.mondayTo ? this.timeModelDialogData.timeModel!.mondayTo : ''
      this.tuesday = check ? empty : this.timeModelDialogData.timeModel!.tuesday
      this.tuesdayFrom = check ? '' : this.timeModelDialogData.timeModel!.tuesdayFrom ? this.timeModelDialogData.timeModel!.tuesdayFrom : ''
      this.tuesdayTo = check ? '' : this.timeModelDialogData.timeModel!.tuesdayTo ? this.timeModelDialogData.timeModel!.tuesdayTo : ''
      this.wednesday = check ? empty : this.timeModelDialogData.timeModel!.wednesday
      this.wednesdayFrom = check ? '' : this.timeModelDialogData.timeModel!.wednesdayFrom ? this.timeModelDialogData.timeModel!.wednesdayFrom : ''
      this.wednesdayTo = check ? '' : this.timeModelDialogData.timeModel!.wednesdayTo ? this.timeModelDialogData.timeModel!.wednesdayTo : ''
      this.thursday = check ? empty : this.timeModelDialogData.timeModel!.thursday
      this.thursdayFrom = check ? '' : this.timeModelDialogData.timeModel!.thursdayFrom ? this.timeModelDialogData.timeModel!.thursdayFrom : ''
      this.thursdayTo = check ? '' : this.timeModelDialogData.timeModel!.thursdayTo ? this.timeModelDialogData.timeModel!.thursdayTo : ''
      this.friday = check ? empty : this.timeModelDialogData.timeModel!.friday
      this.fridayFrom = check ? '' : this.timeModelDialogData.timeModel!.fridayFrom ? this.timeModelDialogData.timeModel!.fridayFrom : ''
      this.fridayTo = check ? '' : this.timeModelDialogData.timeModel!.fridayTo ? this.timeModelDialogData.timeModel!.fridayTo : ''
      this.saturday = check ? empty : this.timeModelDialogData.timeModel!.saturday
      this.saturdayFrom = check ? '' : this.timeModelDialogData.timeModel!.saturdayFrom ? this.timeModelDialogData.timeModel!.saturdayFrom : ''
      this.saturdayTo = check ? '' : this.timeModelDialogData.timeModel!.saturdayTo ? this.timeModelDialogData.timeModel!.saturdayTo : ''
      this.sunday = check ? empty : this.timeModelDialogData.timeModel!.sunday
      this.sundayFrom = check ? '' : this.timeModelDialogData.timeModel!.sundayFrom ? this.timeModelDialogData.timeModel!.sundayFrom : ''
      this.sundayTo = check ? '' : this.timeModelDialogData.timeModel!.sundayTo ? this.timeModelDialogData.timeModel!.sundayTo : ''
      this.selectedType = check ? undefined : this.timeModelDialogData.timeModel!.modelType
    }
  }
})
